import Keycloak from 'keycloak-js';

// Keycloak configuration - using the same realm and client as the React Native app
const keycloakConfig = {
  url: 'https://auth.botwizard.ch',
  realm: 'botwizard',
  clientId: 'admin-console',
};

// Initialize Keycloak instance
const keycloak = new Keycloak(keycloakConfig);

// Initialize Keycloak and authenticate
export const initKeycloak = () => {
  console.log('Keycloak init called with config:', {
    url: keycloakConfig.url,
    realm: keycloakConfig.realm,
    clientId: keycloakConfig.clientId,
    origin: window.location.origin
  });
  
  // Make keycloak instance available globally for backward compatibility
  window.keycloak = keycloak;
  
  return keycloak.init({
    onLoad: 'check-sso',  // Changed from 'login-required' to prevent forced redirects
    checkLoginIframe: false,
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    redirectUri: window.location.origin,
    // Add pkce for better security
    pkceMethod: 'S256',
    // Prevent infinite redirect loops
    enableLogging: true
  }).then(authenticated => {
    console.log('Keycloak authenticated:', authenticated);
    if (!authenticated) {
      console.log('Not authenticated, redirecting to login...');
      keycloak.login({
        redirectUri: window.location.origin
      });
    }
    return authenticated;
  }).catch(error => {
    console.error('Keycloak initialization failed:', error);
    // Don't throw error, just return false
    return false;
  });
};

// Get the current user's token
export const getToken = () => {
  return keycloak.token;
};

// Get user info
export const getUserInfo = () => {
  return keycloak.tokenParsed;
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return keycloak.authenticated;
};

// Check if user has Admin role
export const hasAdminRole = () => {
  if (!keycloak.authenticated || !keycloak.tokenParsed) {
    return false;
  }
  
  // Check realm roles (case insensitive)
  const realmRoles = keycloak.tokenParsed.realm_access?.roles || [];
  if (realmRoles.some(role => role.toLowerCase() === 'admin')) {
    return true;
  }
  
  // Check client roles (case insensitive)
  const clientRoles = keycloak.tokenParsed.resource_access?.[keycloakConfig.clientId]?.roles || [];
  if (clientRoles.some(role => role.toLowerCase() === 'admin')) {
    return true;
  }
  
  return false;
};

// Get all user roles for debugging
export const getUserRoles = () => {
  if (!keycloak.authenticated || !keycloak.tokenParsed) {
    return { realm: [], client: [] };
  }
  
  return {
    realm: keycloak.tokenParsed.realm_access?.roles || [],
    client: keycloak.tokenParsed.resource_access?.[keycloakConfig.clientId]?.roles || []
  };
};

// Refresh token
export const refreshToken = () => {
  return keycloak.updateToken(30);
};

// Manual login
export const login = () => {
  return keycloak.login({
    redirectUri: window.location.origin
  });
};

// Logout
export const logout = () => {
  keycloak.logout({
    redirectUri: window.location.origin
  });
};

// Get the Keycloak instance
export const getKeycloakInstance = () => {
  return keycloak;
};

export default keycloak;